import React from "react";
import style from "./no-canvases-empty-state-new.module.css";
import StyledButton, { ButtonStyle } from "frontend/ui-components/styled-button";
import { CanvasTemplate, BlankCanvasTemplate } from "shared/datamodel/schemas";
import EmptyStateIcon from "frontend/icons/empty-state";

export default function NoCanvasesEmptyStateNew({
  subtitle,
  createNewBoard,
  onDismiss,
  selectedTeamId,
  selectedProjectId,
}: {
  subtitle: string;
  createNewBoard?: ({
    template,
    inputProjectId,
    inputTeamId,
    source,
  }: {
    template: CanvasTemplate;
    inputProjectId: string | null;
    inputTeamId: string | null;
    source: string;
  }) => void;
  onDismiss?: () => void;
  selectedTeamId: string | null;
  selectedProjectId: string | null;
}) {
  return (
    <div className={style.noCanvases}>
      <EmptyStateIcon />
      <span>{subtitle}</span>
      <StyledButton
        style={ButtonStyle.filled}
        title={"Create a new canvas"}
        onClick={() => {
          createNewBoard &&
            createNewBoard({
              template: BlankCanvasTemplate,
              inputProjectId: selectedProjectId,
              inputTeamId: selectedTeamId,
              source: "empty-workspace-or-project",
            });
          onDismiss && onDismiss();
        }}
        customStyle={{
          letterSpacing: "0.124px",
          borderRadius: "6px",
          color: "#FFF",
          fontFamily: "Poppins",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
        }}
        dataTestId="empty-state-create-canvas-button"
      />
    </div>
  );
}
